// Activity Log report i18n keys (used by ActivityLogsListing.vue).
// Page-level keys live under `ActivityLogsListing.*`.

export const reportActivityLogDict: Record<string, [en: string, th: string]> = {
  // ── Page-level keys ──────────────────────────────────────
  "ActivityLogsListing.pageTitle": ["Activity Logs", "บันทึกกิจกรรม"],
  "ActivityLogsListing.breadcrumbReports": ["Reports", "รายงาน"],
  "ActivityLogsListing.breadcrumb": ["Activity Logs", "บันทึกกิจกรรม"],

  // ── Section title ───────────────────────────────────────
  "ActivityLogsListing.sectionTitle": ["Activity Logs", "บันทึกกิจกรรม"],

  // ── Search & filters ────────────────────────────────────
  "ActivityLogsListing.search": ["Search by message, user, or resource", "ค้นหาจากข้อความ ผู้ใช้ หรือรายการ"],
  "ActivityLogsListing.filter.type": ["Activity type", "ประเภทกิจกรรม"],
  "ActivityLogsListing.filter.resource": ["Resource type", "ประเภทรายการ"],
  "ActivityLogsListing.filter.status": ["Status", "สถานะ"],
  "ActivityLogsListing.filter.from": ["From", "ตั้งแต่"],
  "ActivityLogsListing.filter.to": ["To", "ถึง"],

  // ── Status filter options ───────────────────────────────
  "ActivityLogsListing.status.success": ["Success", "สำเร็จ"],
  "ActivityLogsListing.status.failed": ["Failed", "ล้มเหลว"],
  "ActivityLogsListing.status.pending": ["Pending", "รอดำเนินการ"],

  // ── Table column headers ────────────────────────────────
  "ActivityLogsListing.column.time": ["Time", "เวลา"],
  "ActivityLogsListing.column.actor": ["Actor", "ผู้ดำเนินการ"],
  "ActivityLogsListing.column.action": ["Action", "การกระทำ"],
  "ActivityLogsListing.column.resource": ["Resource", "รายการ"],
  "ActivityLogsListing.column.details": ["Details", "รายละเอียด"],
  "ActivityLogsListing.column.status": ["Status", "สถานะ"],

  // ── View changes dialog ─────────────────────────────────
  "ActivityLogsListing.changes.title": ["Change Details", "รายละเอียดการเปลี่ยนแปลง"],
  "ActivityLogsListing.changes.field": ["Field", "ฟิลด์"],
  "ActivityLogsListing.changes.old": ["Old value", "ค่าเดิม"],
  "ActivityLogsListing.changes.new": ["New value", "ค่าใหม่"],
  "ActivityLogsListing.changes.empty": ["No change details available.", "ไม่มีรายละเอียดการเปลี่ยนแปลง"],
  "ActivityLogsListing.changes.viewChanges": ["View {count} change{count|1:;s}", "ดูการเปลี่ยนแปลง {count} รายการ"],
  "ActivityLogsListing.changes.receiptItemBottles": ["View Receipt Bottles", "ดูขวดในใบรับ"],

  // ── Empty / loading ─────────────────────────────────────
  "ActivityLogsListing.loading": ["Loading activity logs…", "กำลังโหลดบันทึกกิจกรรม…"],
  "ActivityLogsListing.empty": ["No activity logs found", "ไม่พบบันทึกกิจกรรม"],
  "ActivityLogsListing.total": ["Total: {total}", "ทั้งหมด: {total} รายการ"],
};
